import { FC, type FocusEventHandler } from 'react';

import cn from 'classnames';
import { IoChevronUp, IoChevronDown } from 'react-icons/io5';

import OInput from '../OInput';
import OButton from '../OButton';

import styles from './oStepperInput.module.scss';

interface IProps {
  value: number | '';
  placeholder?: string;
  onIncrement: () => void;
  onDecrement: () => void;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  readOnly?: boolean;
  className?: string;
  disabled?: boolean;
}

const OStepperInput: FC<IProps> = ({
  value,
  placeholder,
  onIncrement,
  onDecrement,
  onFocus,
  readOnly,
  className,
  disabled,
}) => {
  return (
    <div className={cn(styles.stepperWrapper, className)}>
      <OInput
        value={value === '' ? '' : value.toString().padStart(2, '0')}
        placeholder={placeholder}
        onFocus={onFocus}
        readOnly={readOnly}
        disabled={disabled}
        className={styles.stepperInput}
      />
      <div className={styles.stepperArrows}>
        <OButton
          className={styles.arrowBtn}
          onClick={(e) => {
            e.preventDefault();
            onIncrement();
          }}
          disabled={disabled} // Arrows enabled even if readOnly, unless disabled
          icon={<IoChevronUp />}
        />
        <OButton
          className={styles.arrowBtn}
          onClick={(e) => {
            e.preventDefault();
            onDecrement();
          }}
          disabled={disabled}
          icon={<IoChevronDown />}
        />
      </div>
    </div>
  );
};

export default OStepperInput;
